import alertBadgePlugin from "./alertBadgePlugin";
import alertNotificationsPlugin from "./alertNotificationsPlugin";
import alertHistoryListPlugin from "./alertHistoryListPlugin";
import alertTriggerControlsPlugin from "./alertTriggerControlsPlugin";
import alertTriggersListPlugin from "./alertTriggersListPlugin";
import alertTriggerTogglePlugin from "./alertTriggerTogglePlugin";
import portfolioListPlugin from "./portfolioListPlugin";
import portfolioPlugin from "./portfolioPlugin";
import portfolioPositionsTopFlopPlugin from "@/plugins/portfolioPositionsTopFlopPlugin";
import portfolioPositionsPerformancePlugin from "./portfolioPositionsPerformancePlugin";
import watchlistListPlugin from "./watchlistListPlugin";
import watchlistPlugin from "./watchlistPlugin";
import { PluginObject } from "vue";

export type WidgetConfig = {
  name: PluginObject<any>;
  options: any;
};

export default [
  alertBadgePlugin,
  alertNotificationsPlugin,
  alertHistoryListPlugin,
  alertTriggerControlsPlugin,
  alertTriggersListPlugin,
  alertTriggerTogglePlugin,
  portfolioListPlugin,
  portfolioPlugin,
  portfolioPositionsTopFlopPlugin,
  portfolioPositionsPerformancePlugin,
  watchlistListPlugin,
  watchlistPlugin,
];
